import docCookies from 'doc-cookies';
import { BASE_CONSENT_URL, BASE_URL_SANCTUM } from '../misc/consts';

export default (id, marketingAgreement) => ({
  id: null,
  marketingAgreement: false,
  somethingWentWrong: false,

  async getXsfrToken() {
    const response = await fetch(BASE_URL_SANCTUM);
    if (!response.ok) {
      this.somethingWentWrong = true;
      throw new Error(`Error! status: ${response.status}`);
    }
  },

  async setConsent() {
    this.somethingWentWrong = false;
    await this.getXsfrToken();

    fetch(BASE_CONSENT_URL, {
      body: JSON.stringify({
        id: this.id,
      }),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
        'X-locale': this.$locale(),
      },
      method: 'POST',
    })
      .then(async (response) => {
        if (!response.ok) {
          let errorResponse = await response.json();
          if (errorResponse.error) {
            this.error = errorResponse.error;
          } else {
            this.error = this.$t('general_error');
          }
          throw new Error('Network response was not OK');
        }
        return response.json();
      })
      .catch(() => {
        this.somethingWentWrong = true;
      });
  },

  init() {
    this.id = id;
    this.marketingAgreement = marketingAgreement;
    if (!marketingAgreement) {
      setTimeout(() => {
        this.$dispatch('set-modal', true);
      }, 2000);
    }
  },
});
